import { useEffect, useLayoutEffect, useRef } from "react";
import { filterMessage, isUpdateStreamMessage, listen, } from "@sinch/bus";
const updateStreamOnly = filterMessage(isUpdateStreamMessage);
export const globalConsumerRegistry = {};
export const useUpdateStreamConsumer = (onUpdate, debug = false, globalId) => {
    const onUpdateRef = useRef(onUpdate);
    // use latest ref pattern (fixes issues with multiple messages and changing hook dep list)
    useLayoutEffect(() => {
        onUpdateRef.current = onUpdate;
    });
    // Listen to the bus for update stream messages and forward them to the handler
    useEffect(() => {
        // check for already globally registered consumers
        if (globalId && globalConsumerRegistry[globalId]) {
            debug && console.debug(`SocketConsumer: Unsubscribe from '${globalId}'`);
            // unsubscribe to prevent multiple subscriptions
            globalConsumerRegistry[globalId]();
        }
        const unsubscribe = listen(updateStreamOnly((message) => {
            // eslint-disable-next-line no-console
            debug &&
                console.debug("SocketConsumer: Consuming message from bus.", message);
            onUpdateRef.current(message);
        }));
        if (!globalId) {
            return unsubscribe;
        }
        else {
            debug &&
                console.debug(`SocketConsumer: Add global subscription for '${globalId}'`);
            globalConsumerRegistry[globalId] = unsubscribe;
        }
    }, [debug, globalId]);
    return;
};
